export default __webpack_public_path__ + "static/media/louise.fafbeac3.jpg";